( function( $ ) {
	// From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes#polyfill
	if (!String.prototype.includes) {
		String.prototype.includes = function(search, start) {
			'use strict';

			if (search instanceof RegExp) {
				throw TypeError('first argument must not be a RegExp');
			}
			if (start === undefined) { start = 0; }
			return this.indexOf(search, start) !== -1;
		};
	}

	var currentHash = false;

	$( window ).on( 'hashchange', function( e ) {
		var hash = window.location.hash;

		if ( '#!' !== hash.substr(0,2)) {
			// MSR-664 This isn't a real tab, so don't treat it as one.
			return;
		}

		var hashParts = hash.split(':');
		var tabHash = false;

		if ( hashParts.length > 1 ) {
			hash = hashParts[0];
			tabHash = hashParts[1];
		}

		var $targetTab = $( 'a[href="' + hash + '"]' );


		if ( hash === '' ) {
			$targetTab = $( '.c-tabs__tablist a:first' );
		}

		if ( $targetTab.length && currentHash !== hash ) {
			$targetTab.click();
			var adminbar_height = 0, $adminbar = $( '#wpadminbar' );
			var viewport_top = $( window ).scrollTop();
			if ( $adminbar.length ) {
				adminbar_height = $adminbar.height();
			}

			var offset = $targetTab.offset();

			currentHash = hash;

			if ( viewport_top > offset.top ) {

				if ( ! tabHash ) {
					var top = offset.top - adminbar_height;
					$( 'html, body' ).animate( {
						scrollTop: top
					}, 300);
				}
			}

			if ( tabHash ) {
				setTimeout(function(){window.location.hash = hash + ':' + tabHash; }, 100);
			}


		} else if ( tabHash ) {
			var relativeElem = document.getElementById(tabHash);
			$( 'html, body' ).animate( {
				scrollTop: $(relativeElem).offset().top
			}, 10);
		}
	} );

	// get the next number in a set, which loops back to the beginning
	var getNext = function( n, i ) {
		return ( i + 1 >= n ) ? 0 : i + 1;
	};

	// get the previous number in a set, which loops back to the end of the set
	var getPrev = function( n, i ) {
		return ( i - 1 < 0 ) ? n - 1 : i - 1;
	};

	var createOnClick = function( e ) {
		var i = e.data.i;
		var self = e.data.self;

		e.preventDefault();
		// switch tab to specified by index
		self.switchTo( i );
	};

	var createTabOnKeydown = function( e ) {
		var i = e.data.i;
		var tab = e.data.tab;
		var self = e.data.self;
		var lng = self.$tablinks.length;

		// strike up or left in the tab => previous tab
		if ( ( e.keyCode == 37 || e.keyCode == 38 ) && !e.ctrlKey ) {
			e.preventDefault();
			// switch to previous tab, looping back to last tab if at beginning of set
			self.switchTo( getPrev( lng, tab.index ) );
		}
		// strike down or right in the tab => next tab
		else if ( ( e.keyCode == 40 || e.keyCode == 39 ) && !e.ctrlKey ) {
			e.preventDefault();
			// switch to next tab, looping back to first tab if at end of set
			self.switchTo( getNext( lng, tab.index ) );
		}
		// strike home in the tab => 1st tab
		else if ( e.keyCode == 36 ) {
			e.preventDefault();
			// switch to the first tab of the set
			self.switchTo( 0 );
		}
		// strike end in the tab => last tab
		else if ( e.keyCode == 35 ) {
			e.preventDefault();
			// switch to the last tab of the set
			self.switchTo( lng - 1 );
		}

	};

	var createPanelOnKeydown = function( e ) {
		var tab = e.data.tab;
		var self = e.data.self;
		var lng = self.$tablinks.length;

		// strike up + ctrl => go to header
		if ( e.keyCode == 38 && e.ctrlKey ) {
			e.preventDefault();
			// set focus on the tab anchor associated with the current tab
			setTimeout( function(){ tab.$el.focus(); }, 0 );
		}
		// strike pageup + ctrl => go to prev header
		else if ( e.keyCode == 33 && e.ctrlKey ) {
			e.preventDefault();
			// switch to previous tab, looping back to last tab if at beginning of set
			// removes focus on elements inside tabpanel and focuses on previous tab anchor
			self.switchTo( getPrev( lng, tab.index ) );
		}
		// strike pagedown + ctrl => go to next header
		else if ( e.keyCode == 34 && e.ctrlKey ) {
			e.preventDefault();
			// switch to next tab, looping back to first tab if at end of set
			// removes focus on elements inside tabpanel and focuses on next tab anchor
			self.switchTo( getNext( lng, tab.index ) );
		}

	};

	var tabSet = function( el ) {
		var self = this;
		this.$el = $( el );
		this.$tablist = this.$el.find( '.c-tabs__tablist' );
		this.$tablinks = this.$tablist.find( 'a' );
		this.tabs = {};

		var tabObj = function( i, el ) {
			var tab = this;
			this.anchor = el.getAttribute( 'href' ).replace( /^(#\!{0,1})/, '' );
			this.index = i;

			this.$el = $( el );
			this.$tabpanel = $( document.getElementById( this.anchor ) );
			this.$tabpanel_header = $( this.anchor+' '+self.$el.data( 'header' ) );
		};

		// change aria attribute values to indicate that the tab contents are showing
		tabObj.prototype.showPanel = function( focus ) {
			if ( focus === undefined ) {
				var focus = true;
			}

			var tab = this;
			// set tab as 'selected', 'active' and focusable by adding to tab order
			this.$el.attr( {'aria-selected': true} ).addClass( 'active' );
			// set focus on tab
			if ( focus ) {
				setTimeout( function(){ tab.$el.focus(); }, 0 );
				//add BI event
				window.MSR.wedecsBi.sendCustomEvent( tab.$el, {
					'ms.interactionType': 4,
					'data-bi-slot': tab.index
				} );
			}
			// set tabpanel as visible, and remove the tab order (which was probably set to -1)
			this.$tabpanel.attr( 'aria-hidden', false ).css( 'visibility', 'visible' );
			// set focus on tabpanel heading element
			this.$tabpanel_header.focus();

		};

		// change aria attribute values to indicate that the tab contents are hidden
		tabObj.prototype.hidePanel = function() {
			// remove 'selected' and 'active' states on tab, and remove it from tab order
			this.$el.attr( {'aria-selected': false} ).removeClass( 'active' );
			// hide tabpanel and remove it from tab order
			this.$tabpanel.attr( {'aria-hidden': true} ).css( 'visibility', 'hidden' );
		};

		tabObj.prototype.createPanel = function( index, total ) {
			// add aria attributes
			this.$el.parent( 'li' ).attr( 'role','presentation' );
			this.$el.attr( 'role', 'tab' ).attr( 'aria-controls', this.anchor ).attr( 'aria-setsize', total ).attr( 'aria-posinset', index );
			this.$tabpanel.attr( 'role', 'tabpanel' ).attr( 'aria-labelledby', this.$el.attr( 'id' ) );
		};

		tabObj.prototype.removePanel = function() {
			// remove aria attributes and any 'active' classes or display properties that have been applied
			this.$el.parent( 'li' ).removeAttr( 'role' );
			this.$el.removeAttr( 'role aria-controls aria-selected aria-setsize aria-posinset' ).removeClass( 'active' );
			this.$tabpanel.removeAttr( 'role aria-labelledby aria-hidden' ).css( 'display', '' );
		};

		/**
		 * Changes parent background depending on current tab
		 */
		tabObj.prototype.changeBackground = function() {
			var tabType = this.$tabpanel.data( 'view' );

			if ( tabType !== '' && tabType !== 'card' ) {
				this.$tabpanel.removeClass( 'msr-light-gray-bgc' );
				this.$tabpanel.removeClass( 'padding-horizontal' );
			} else {
				this.$tabpanel.addClass( 'msr-light-gray-bgc' );
				this.$tabpanel.addClass( 'padding-horizontal' );
			}
		};

		// create tabs in this set
		this.tabs = this.$tablinks.map( function( i, el ) {
			// init a new object created from anchor element
			var tab = new tabObj( i, el );

			// return tab object into an array for storage
			return tab;
		} ).toArray();

		this.build();

	};

	tabSet.prototype.build = function() {
		var self = this;
		var initialtabIndex = parseInt( this.$el.attr( 'data-initial-tab-index' ) );

		// add a class to component to mark it as activated
		this.$el.addClass( 'c-tabs__activated' );

		// add aria and show the tablist dom elements
		this.$tablist.attr( 'role', 'tablist' );

		// loop through all tabObjs stored in tabs array
		for ( var i = 0; i < this.tabs.length; i++ ) {
			var tab = this.tabs[i];
			// setup the tab and its panel as an "accessible tabs" component
			tab.createPanel( ( i + 1 ), this.tabs.length );

			// create listeners for the tab's link
			tab.$el.on( 'click', {i: i, tab: tab, self: self}, createOnClick ).on( 'keydown', {i: i, tab: tab, self: self}, createTabOnKeydown );
			// create listener for the tab's panel
			tab.$tabpanel.on( 'keydown', {tab: tab, self: self}, createPanelOnKeydown );
		}

	    if ( window.location.hash ) {
		    $( window ).trigger( 'hashchange' );
	    } else {
			if ( ! isNaN ( initialtabIndex ) ) {
				self.switchTo( initialtabIndex, false, true );
			} else {
				self.switchTo( 0, false, true );
			}
		}

		// return tabSet object for chaining
		return this;
	};

	tabSet.prototype.destroy = function() {
		// remove class on component that marks it as activated
		this.$el.removeClass( 'c-tabs__activated' );

		// remove aria and any 'active' classes or display properties that have been applied
		this.$tablist.removeAttr( 'role' );

		// loop through all tabObjs stored in tabs array
		for ( var i = 0; i < this.tabs.length; i++ ) {
			var tab = this.tabs[i];
			// remove anything that makes this an "accessible tabs" component
			tab.removePanel();

			// remove all event listeners that were added
			tab.$el.off( 'click', createOnClick ).off( 'click', createTabOnKeydown );
			tab.$tabpanel.off( 'keydown', createPanelOnKeydown );
		}

		// return tabSet object for chaining
		return this;
	};

	var prevTab = 0;
	var switchTo = function( n, focus, firstSwitch ) {
		// hide all tab panels
		if ( 0 === this.tabs.length ) {
			return;
		}
		for ( var i = 0; i < this.tabs.length; i++ ) {
			var tab = this.tabs[i];
			if ( i !== n ) {
				tab.hidePanel();
			}
		}

		// show specified panel
		this.tabs[n].showPanel( focus );

		// Actually hide everything else.
		this.hideInactiveTabs( n );
		//
		// Change background if needed.
		this.tabs[n].changeBackground( focus );

		if ( !firstSwitch ) {
			if ( prevTab === n ) {
				return;
			}
			if ( n === 0 ) {
				if ( window.location.hash !== '' ) {
					history.replaceState( null, null, ' ' );
					currentHash = false;
				}
			} else {
				window.location.hash = '!' + this.tabs[n].anchor;
			}
			prevTab = n;

		}

	};

	tabSet.prototype.switchTo = switchTo;

	tabSet.prototype.hideInactiveTabs = function( index ) {
		var tabs = this.tabs.slice(),
			activeTab = tabs[ index ];

		delete tabs[ index ];

		for ( var i = 0; i <= tabs.length; i++ ) {
			if ( undefined !== tabs[ i ] ) {
				tabs[ i ].$tabpanel.hide();
			}

			if ( ! activeTab.$tabpanel.is( 'visible' ) ) {
				activeTab.$tabpanel.show();
			}
		}
	};

	var constructTabSet = function( el ) {
		if ( document.querySelector( el ) !== null ) {
			return new tabSet( el );
		}
	};

	// MSR-1242 Redirect people tabs with #! approach
	var hash = window.location.hash;
	var loc = window.location;
	if ( hash.length && loc.href.includes('/people/') ) {
		var newPath = loc.pathname + '/' + loc.hash;
		newPath = newPath.replace('/#!','/').replace('//','/'); // Add the path fragment

		var newUrl = loc.protocol + '//'+
			loc.hostname + (loc.port?":"+loc.port:"") +
			newPath + ( loc.search ? loc.search: '' );

		window.location.replace(newUrl);
	}

	// expose tabSet object to global scope for use
	window.tabSet = constructTabSet;


} )( window.jQuery );
